module.exports = ".active\r\n{\r\n    font-weight: bold;\r\n}"